import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer'

const useCurrentDb = () : [string | null , string | null] => {
  const bookDb = useSelector((state: RootState) => state.bookDb)
  const sheetDb = useSelector((state: RootState) => state.sheetDb)
  return [sheetDb.currentSheetId, bookDb.currentBookId]
}

export default useCurrentDb